import {
    TransactionColumn,
    TransactionView,
} from "@common/types/views/transactionViews";
import { NamedView, ViewType } from "@common/types/views/views";

export const SCHEDULES_REVIEW_VIEW_ID = "schedules-review";

export const createSchedulesReviewView = (
    entityIds: number[],
): NamedView<TransactionView> => ({
    id: SCHEDULES_REVIEW_VIEW_ID,
    name: "Accrual review",
    type: ViewType.TRANSACTION,
    options: {
        bulkActions: true,
        selection: true,
    },
    columns: [
        {
            id: TransactionColumn.DATE,
            options: {
                pin: "left",
            },
        },
        {
            id: TransactionColumn.BANK_DESCRIPTION,
        },
        {
            id: TransactionColumn.COUNTERPARTY,
        },
        {
            id: TransactionColumn.AMOUNT,
        },
        {
            id: TransactionColumn.ACCOUNT,
        },
        {
            id: TransactionColumn.LEDGER,
        },
        {
            id: TransactionColumn.ACCRUAL_LEDGER,
        },
        {
            id: TransactionColumn.SCHEDULE,
        },
        {
            id: TransactionColumn.TRANSFER_MATCH,
        },
        {
            id: TransactionColumn.ENTITY,
            options: {
                pin: "right",
            },
        },
    ],
    filters: {
        entityIds,
    },
});
